import React from 'react';
import { motion } from 'framer-motion';
export function Hook() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative" data-id="element-177">
      <div className="max-w-4xl mx-auto text-center" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-179">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-espresso leading-tight mb-8" data-id="element-180">
            "¿Sabías que las galletas rellenas y el hojaldre artesanal son los
            productos con{' '}
            <span className="text-caramel italic" data-id="element-181">
              mayor margen de ganancia
            </span>{' '}
            en la repostería actual?"
          </h2>

          <div className="w-24 h-1 bg-caramel mx-auto mb-8 rounded-full" data-id="element-182"></div>

          <p className="text-xl md:text-2xl text-espresso-light font-sans max-w-3xl mx-auto leading-relaxed" data-id="element-183">
            No necesitas máquinas caras ni un local físico. Solo necesitas las
            recetas correctas y un método probado.
          </p>
        </motion.div>
      </div>
    </section>;
}